export default __webpack_public_path__ + "static/media/tdr_logo_clear_bg.e0213402.png";